// Изписвания — заявките, добавени с редизайна: справката с анулираните и
// анулирането с причина. Заварените (create, update, getWriteoff…) са още в
// `inventory.ts` и се местят тук при всяка задача, която ги докосва.
// Договорът е в docs/cross-repo-contract.md.
import { api } from "./client";
import type { Writeoff } from "./inventory";
import type { DocumentStatusFilter } from "./inventoryPostings";

export type WriteoffsReportParams = {
  startDate: string;
  endDate: string;
  status?: DocumentStatusFilter;
};

// Справката „Изписвания" — всички складове, по избор и анулираните. Стар BE не
// знае `status` и връща само активните — справката тогава просто няма анулирани.
export async function getWriteoffsReport(
  params: WriteoffsReportParams,
): Promise<Writeoff[]> {
  const res = await api.get<Writeoff[]>("/inventory/writeoffs", { params });
  return res.data;
}

// Анулиране с причина. Причината е НЕЗАДЪЛЖИТЕЛНА и отива в тялото на DELETE
// (`annulReason` — `reason` вече е заето за причината за брак); стар BE я
// игнорира и анулира както досега.
export async function annulWriteoff(
  id: number,
  annulReason: string | null,
): Promise<void> {
  await api.delete(`/inventory/writeoffs/${id}`, {
    data: annulReason ? { annulReason } : undefined,
  });
}
